/**
 * 常用的form表单验证
 */
import ElementUI from "element-ui";

// 验证手机号格式
export const validateMobile = (rule, value, callback) => {
  const regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
  if (!regExp.test(value)) {
    callback(new Error("请输入正确定手机号"));
  } else {
    callback();
  }
};

// 验证邮箱格式
export const validateEmail = (rule, value, callback) => {
  const regExp = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
  if (!regExp.test(value)) {
    callback(new Error("请输入正确的邮箱"));
  } else {
    callback();
  }
};

// 身份证号
export const identifyIdPattern = () => {
  return /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
};

// 金额
export const moneyPattern = () => {
  return /^[1-9][0-9]*([.][0-9]+)?$/;
};

// 手机号
export const mobilePattern = () => {
  return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
};

// 邮箱
export const emailPattern = () => {
  return /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
};

/**
 * 文件格式验证
 * @param {file} file file文件
 * @param {string|Array} rules 合法的格式
 * @returns {boolean} 是否合法
 */
export const validateFileType = (file, rules) => {
  let valid = false;
  let type = typeof rules;

  if (type === "string") {
    valid = file.type.indexOf(rules) >= 0;
  } else if (Array.isArray(rules)) {
    valid = rules.some(item => file.type.indexOf(item) >= 0);
  }

  !valid && ElementUI.Message.warning(`请上传指定格式的文件`);
  return valid;
};

/**
 * 文件大小验证
 * @param {file} file file文件
 * @param {string} limit 大小限制，如：2kb、2M
 * @returns {boolean} 是否合法
 */
export const validateFileSize = (file, limit) => {
  let valid = true;

  // 无需验证大小
  if (!limit) return true;

  // 格式化
  limit = typeof limit === "string" ? limit.toLowerCase() : limit + "m";

  if (limit.indexOf("m") >= 0) {
    // M
    valid = Number(limit.replace(/m/g, "")) * 1024 * 1024 >= file.size;
  } else if (limit.indexOf("k") >= 0) {
    // KB
    let result = "";
    result = limit.replace(/kb/g, "");
    result = limit.replace(/k/g, "");
    valid = Number(result) * 1024 >= file.size;
  }

  !valid && ElementUI.Message.warning(`请上传${limit}以内的文件`);
  return valid;
};
